<div class="flex flex-column justify-content-center align-items-center w-full md:px-8 pb-3">
    <img src="/assets/images/signup/SignupPage-400.webp" alt="Phones" class="max-h-12rem  md:max-h-18rem" />

    <!-- INITIAL -->
    <ng-container *ngIf="mode === 'initial'">
        <div class="text-center text-2xl md:text-4xl font-bold text-black-alpha-90">{{ offer?.title }}</div>

        <span class="text text-center">
    </span>

        <div class="mt-3 text-center" *ngIf="offer?.body?.length">
            <p class="m-0" *ngFor="let line of offer.body">{{ line }}</p>
        </div>
        <div class="text text-center mt-3">
            <a (click)="intercom.openMessenger()" class="underline text-gray-600 cursor-pointer">Contact support</a>
            if you have any questions or need help!
        </div>

        <div class="w-full grid mt-4">

            <div class="col-12  py-2">
                <p-button
                    [label]="offer?.ctaLabel"
                    styleClass="learn-btn w-full"
                    severity="secondary"
                    [loading]="isLoading"
                    (onClick)="primaryAction()"
                ></p-button>
            </div>
        </div>
    </ng-container>

    <!-- SUCCESS -->
    <ng-container *ngIf="mode === 'success'">
        <h2 class="text-center mb-2">{{ offer?.successTitle }}</h2>
        <span class="text text-center">{{ offer?.successBody }}</span>

        <div class="w-full grid mt-4">
            <div class="col-12 py-2">
                <p-button label="Got it" styleClass="learn-btn w-full" severity="secondary" (onClick)="close()"></p-button>
            </div>
        </div>
    </ng-container>

    <!-- ERROR -->
    <ng-container *ngIf="mode === 'error'">
        <h2 class="text-center mb-2">{{ offer?.errorTitle }}</h2>

        <span class="text text-center mt-3">
      {{ errorMessage || offer?.errorBody }}
    </span>

        <div class="w-full grid mt-4">
            <div class="col-12 py-2">
                <p-button label="Got it" styleClass="learn-btn w-full" severity="secondary" (onClick)="close()"></p-button>
            </div>
        </div>
    </ng-container>
</div>
